module.exports = __webpack_public_path__ + "static/media/燴炒黑椒雞肉.a57e928a.jpg";